export default function preventBubble(func) {
  return function(event) {
    event.stopPropagation();
    func?.(event);
  };
}
